import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing-page';
import Login from './pages/login';
import SharedProfileDashboard from './pages/shared-profile-dashboard';
import EncounterManagement from './pages/encounter-management';
import AICommunicationHub from './pages/ai-communication-hub';
import MoodTracker from './pages/mood-tracker';
import PartnerOnboarding from './pages/partner-onboarding';
import IntimacyScheduler from './pages/intimacy-scheduler';
import ProfileSettings from './pages/profile-settings';
import AIAnalyticsDashboard from './pages/ai-analytics-dashboard';
import AdminDebugConsole from './pages/admin-debug-console';
import NotificationContainer from './components/ui/NotificationContainer';
import { AuthProvider } from './contexts/AuthContext';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <ScrollToTop />
          <NotificationContainer />
          <RouterRoutes>
            {/* Define your route here */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/shared-profile-dashboard" element={<SharedProfileDashboard />} />
            <Route path="/encounter-management" element={<EncounterManagement />} />
            <Route path="/ai-communication-hub" element={<AICommunicationHub />} />
            <Route path="/mood-tracker" element={<MoodTracker />} />
            <Route path="/partner-onboarding" element={<PartnerOnboarding />} />
            <Route path="/intimacy-scheduler" element={<IntimacyScheduler />} />
            <Route path="/profile-settings" element={<ProfileSettings />} />
            <Route path="/ai-analytics-dashboard" element={<AIAnalyticsDashboard />} />
            <Route path="/admin-debug-console" element={<AdminDebugConsole />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
